<template>
    <div class="audio_warrp clearfix">
        <div class="play_pause">
            <img :id="'isplay'+item.id"
                 src="./img/icon_start.png"
                 alt=""
                 v-show="isplay"
                 @click="start(item)">
            <img :id="'pause'+item.id"
                 v-show="!isplay"
                 src="./img/icon_suspend.png"
                 alt=""
                 @click="pause">
        </div>
        <div class="audio_all"
             :id="'audio_all'+item.id">
            <div class="audio_now"
                 :id="'audio_now'+item.id"
                 :style="audioWidth"></div>
        </div>
        <!-- <audio src="" :id="'audio'+item.id" ref="audio" @timeupdate="playing" @ended="ended" key="1" @canplay="audioCanPlay"></audio> -->
    </div>
</template>

<script type="text/ecmascript-6">
export default {
    data () {
        return {
            isplay: true,
            audioSrc: "",
            audioCurrentTime: 0,//播放当前进度
            audioDuration: 1,
            // getListTimer: null, //h5播放定时器
            finish: true,   //是否在暂停状态
            Speed: 1,
            proBar: null,  //进度条定时器
            prevId: null,//上一个音频id


            listen_audio: null //听力地址
        }
    },
    props: ['ado', 'sid'],
    computed: {
        item () { return this.ado },
        audioWidth () {
            return {
                width: (this.audioCurrentTime / this.audioDuration) * 100 + '%'
            }
        },
    },
    created () {
        this.prevId = this.$store.state.english.audioId;
    },
    methods: {
        clearIn () {
            window.clearInterval(this.proBar);
        },
        playOut (progress, source) {
            let _this = this;
            this.proBar = setInterval(() => {
                // _this.audioCurrentTime = (_this.Speed++)*0.1
                _this.isplay = false

                if (_this.Speed >= 100) {
                    clearInterval(this.proBar);
                    _this.Speed = 0;
                    _this.isplay = true
                }
                progress.style.width = (_this.Speed++) + '%'
            }, source * 100);
            //console.log(_this.isplay)
        },
        start (source) {
            //console.log(this.isplay)
            if (!this.isplay) {
                return false
            }
            // 音频时间
            if (source.duration < 0 || source.duration == 0 || !source.duration) {
                source.duration = 1
            } else {
                this.audioDuration = source.duration
            }
            this.clearIn()
            // this.proBar && clearInterval(this.proBar);
            // 音频地址
            if (this.listen_audio != source.listen_audio) {
                this.listen_audio = source.listen_audio
                // try {
                //     // 播放
                //     appobject.Interactive("ys_start_audio," + source.listen_audio);
                // } catch(e) {
                //     //console.log('播放')
                // }
                this.appFunction("ys_start_audio", source.listen_audio);
                //console.log('不一样')
            } else {
                //console.log('一样')
                if (this.finish) {
                    // try {
                    //     // 播放
                    //     appobject.Interactive("ys_start_audio," + source.listen_audio);
                    // } catch(e) {
                    //     //console.log('播放')
                    // }
                    this.appFunction("ys_start_audio", source.listen_audio);
                } else {
                    // try{
                    //     // 继续播放
                    //     appobject.Interactive("ys_goon_audio");
                    // }catch(e){
                    //     //console.log('继续')
                    // }
                    this.appFunction("ys_goon_audio");
                }
            }
            this.isplay = false
            let progress = document.getElementById('audio_now' + this.item.id)
            this.playOut(progress, source.duration)

            // let _this = this

            // let progress = document.getElementById('audio_now'+this.item.id)
            // // 如果没有时间  默认为0
            // if(this.sid==92){
            //     if(source.listen_duration < 0 || source.listen_duration == 0 ){
            //         source.duration = 1;
            //     }else{
            //         this.audioDuration = source.listen_duration;
            //         source.duration = source.listen_duration;

            //     }
            // }else{
            //     
            // }
            // if(this.finish) {
            //     try {
            //         // 播放
            //         appobject.Interactive("ys_start_audio," + source.listen_audio);
            //     } catch(e) {
            //         //console.log('播放')
            //     }
            // } else {
            //     try{
            //         // 继续播放
            //         appobject.Interactive("ys_goon_audio");
            //     }catch(e){
            //         //console.log('继续')
            //     }
            // }
            // // setTimeout(()=>{
            // //     playfinished();
            // // },source.duration*1000);
            // this.out(source.duration * 1000)
            // playfinished = function() {
            //     _this.isplay = false
            //     _this.finish = true
            //     _this.audioCurrentTime = 0
            //     progress.style.width = 0 + 'px'
            //     _this.Speed = 1
            //     _this.proBar && clearInterval(_this.proBar);
            //     try {
            //         appobject.Interactive('ys_stop_audio')
            //     } catch(e) {
            //         //console.log('结束')
            //     }
            //      // _this.$store.commit('setPlayId',false);
            // }
        },
        pause () {
            this.isplay = true;
            // this.finish = false
            this.clearIn()
            // // this.getListTimer && clearTimeout(this.getListTimer);
            // try {
            //     appobject.Interactive('ys_pause_audio')
            // } catch(e) {
            //     //console.log(e)
            // }
            this.appFunction("ys_pause_audio");
        },
    },
    destroyed () {
        this.clearIn()
        // try{
        //     appobject.Interactive('ys_stop_audio')
        // }catch(e){
        //     //console.log(e)
        // }
        this.appFunction("ys_stop_audio");
        this.$store.commit('setPlayId', false);
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";
.audio_warrp {
    position: relative;
    width: 100%;
    height: 96px / $ppr;
}
.audio_all {
    width: 520px / $ppr;
    height: 24px / $ppr;
    background-color: #c9c9c9;
    position: absolute;
    top: 50%;
    right: 100px / $ppr;
    margin-top: -12px / $ppr;
    border-radius: 12px / $ppr;
    overflow: hidden;
    .audio_now {
        width: 0%;
        height: 100%;
        background-color: #5e89ef;
        border-radius: 12px / $ppr;
    }
}
.play_pause {
    width: 54px / $ppr;
    height: 54px / $ppr;
    border-radius: 50%;
    position: absolute;
    top: 21px / $ppr;
    left: 25px / $ppr;
    // background-color:#78e5a4;
    img {
        width: 54px / $ppr;
        height: 54px / $ppr;
        // position: absolute;
        // top:18px/$ppr;
        // left:18px/$ppr;
    }
}
</style>
